<template>
    <div>
        <table-page
            :client="client"
            @updated="getReimbursements"
            :warnings="warnings"
            :changelogs="changelogs"
            :hideTabs="true"
        >
            <fast-table
                :recordLabel="recordLabel"
                :sections="sections"
                :headers="headers"
                :data="tableData"
                :activeRowId="currentReimbursementId"
                @click="currentReimbursementId = $event.id"
            >
                <template v-slot:table-actions>
                    <button class="btn btn-primary btn-collapse" id="addReimbursementButton" @click="openAddReimbursementModal">
                        <i class="far fa-fw fa-plus"></i> <span class="btn-text">Add Reimbursement</span>
                    </button>
                </template>
            </fast-table>

            <add-reimbursement-modal v-if="addReimbursementModalOpen" :client="client" :clientReimbursementTypes="reimbursements" ref="addReimbursementModal" @updated="getReimbursements" @close="addReimbursementModalOpen = false"/>
        </table-page>

        <reimbursement-sidebar
            v-if="currentReimbursement"
            :client="client"
            :reimbursement-id="currentReimbursement.id"
            ref="reimbursementSidebar"
            @updated="getReimbursements"
            @close="currentReimbursementId = null"
        >
        </reimbursement-sidebar>
    </div>
</template>

<script>
import TablePageMixin from '@/mixins/TablePageMixin'
import FastTable from '@/components/FastTable'
import ReimbursementSidebar from './components/Reimbursements/ReimbursementSidebar'
import AddReimbursementModal from './components/Reimbursements/AddReimbursementModal'

export default {
    components: {FastTable, ReimbursementSidebar, AddReimbursementModal},
    mixins: [TablePageMixin],
    props: ['client'],
    computed: {
        currentReimbursement() {
            return this.reimbursements.find(e => (e.id == this.currentReimbursementId))
        },
        sections() {
            let sections = [
                {title: 'Active', defaultIsClosed: false, id: 'active', hasDateFilter: false},
                {title: 'Inactive', defaultIsClosed: true, id: 'inactive', hasDateFilter: true},
            ]
            return sections
        },
        activeReimbursements() {
            return this.reimbursements.filter((p) => {return p.is_active})
        },
        inactiveReimbursements() {
            return this.reimbursements.filter((p) => {return !p.is_active})
        },
        tableData() {
            const tableData = []
            const subsets = [
                this.activeReimbursements,
                this.inactiveReimbursements,
            ]

            subsets.forEach(reimbursements => {
                const sectionData = []

                reimbursements.forEach(reimbursement => {
                    sectionData.push({
                        id: reimbursement.id,
                        object: reimbursement,
                        cells: this.makeReimbursementTableData(reimbursement),
                    })
                })
                tableData.push(sectionData)
            })
            return tableData
        },
    },
    data() {
        return {
            reimbursements: [],
            dataLoaded: false,
            currentReimbursementId: null,
            recordLabel: "Reimbursements",
            headers: [
                {label: 'Company', classes: 'cell-company', isFilterable: true, isSearchable: false, defaultSort: true},
                {label: 'Reimbursement Name', classes: '', isSearchable: true, isFilterable: true},
                {label: 'Positions', classes: 'cw-4', isSearchable: false},
            ],
            addReimbursementModalOpen: false
        }
    },
    mounted() {
        this.$store.dispatch('SET_PAGE_TITLE', 'Settings / Reimbursements')
        this.getReimbursements()
    },
    methods: {
        getReimbursements() {
            this.$store.dispatch('START_LOADING')
            this.$api.get(`/clients/${this.client.id}/settings/reimbursement-types`).then(resp => {
                this.reimbursements = resp
                this.$store.dispatch('STOP_LOADING')
            }).catch((errors) => {
                this.$store.dispatch('STOP_LOADING')
                if (errors.__status__ == 403) {
                    this.$bus.$emit('no-access')
                }
                else {
                    this.$bus.showError(errors.__all__)
                }
            })
        },
        makeReimbursementTableData(reimbursement) {
            return [
                reimbursement.company.name,
                reimbursement.name,
                reimbursement.num_positions,
            ]
        },
        openAddReimbursementModal() {
            this.addReimbursementModalOpen = true
        }
    },
}
</script>
